/**
 * Determines the placement status for a floor based on files assigned to it.
 * Only considers files where placed_on_zone_id matches the floor.
 *
 * @param {string} floorId
 * @param {Array|null} files
 * @returns {"none"|"not-placed"|"placed"}
 */
export function getFloorPlacementStatus(floorId, files) {
  if (!files || files.length === 0) return "none"

  const floorFiles = files.filter(file => file.placed_on_zone_id === floorId)
  if (floorFiles.length === 0) return "none"

  const allPlaced = floorFiles.every(file => file.placement_status === "PLACED")
  return allPlaced ? "placed" : "not-placed"
}

/**
 * Counts floors across all buildings by placement status.
 *
 * @param {Array} buildingItems
 * @returns {{all: number, none: number, "not-placed": number, placed: number}}
 */
export function getBuildingFloorStatusCounts(buildingItems) {
  const counts = { all: 0, none: 0, "not-placed": 0, placed: 0 }

  for (const building of buildingItems) {
    if (!building.floors) continue

    for (const floor of building.floors) {
      counts.all += 1
      if (floor.placementStatus in counts) {
        counts[floor.placementStatus] += 1
      }
    }
  }

  return counts
}

/**
 * Filters sidebar items by floor placement status. Inbox always included.
 * Buildings with no matching floors are removed.
 *
 * @param {Array} sidebarItems
 * @param {string} filter
 * @returns {Array}
 */
export function filterBuildingsByFloorStatus(sidebarItems, filter) {
  if (filter === "all") return sidebarItems

  return sidebarItems
    .map(item => {
      if (item.type !== "building") return item

      const matchingFloors = (item.floors || []).filter(floor => floor.placementStatus === filter)
      if (matchingFloors.length === 0) return null

      return { ...item, floors: matchingFloors }
    })
    .filter(Boolean)
}
